import { IConnector } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const connectorApi = crudEndpointsFactory<IConnector>()('connectors', 'Connectors');
